<div class="text-center">
  <h1>{{ "biometric.title" | i18next }}</h1>
  <p>{{ "biometric.description" | i18next }}</p>
  <code-input
    class="margin-b-1"
    [isCodeHidden]="true"
    (codeCompleted)="onCodeCompleted($event)"
  >
  </code-input>
  <br />
  <div (click)="loadSession()">
    <svg
      enable-background="new 0 0 283.46 283.46"
      height="40px"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 283.46 283.46"
      width="64px"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <g>
          <path
            d="M22.855,81.087    C9.543,107.082,4.61,137.596,10.832,168.451"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="8"
          />
          <path
            d="M200.875,21.835    c-25.543-12.538-55.271-17.06-85.321-11.001c-34.136,6.882-62.593,26.187-81.618,52.257"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="8"
          />
          <path
            d="M273.164,115.555    c-7.06-35.013-27.189-64.056-54.285-83.07"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="8"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M275.877,144.695    c0.184-9.594-0.666-19.357-2.641-29.154"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="8"
          />
          <path
            d="M10.904,168.438    c0.388,1.921,0.814,3.824,1.279,5.709"
            fill="none"
            stroke="#000000"
            stroke-linecap="round"
            stroke-miterlimit="10"
            stroke-width="8"
          />
        </g>
      </g>
      <path
        d="M107.454,271.29  c29.977-34.119,44.249-81.34,34.579-129.294"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M119.176,220.338  c-6.555,16.798-16.443,32.131-29.02,45.026"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M126.187,274.896  c29.051-37.175,42.302-86.333,32.245-136.205l0.052-0.017c-1.836-9.104-10.703-14.996-19.807-13.16  c-9.103,1.836-14.994,10.703-13.159,19.808l0.119-0.02c3.746,18.581,3.45,37.04-0.284,54.465"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M110.51,156.144  c5.245,38.701-9.215,76.082-36.162,101.293"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M178.494,171.434  c-0.033-11.89-1.227-23.95-3.666-36.049l0.037-0.014c-3.659-18.152-21.34-29.901-39.492-26.24  c-13.559,2.734-23.546,13.292-26.203,26.027"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M146.273,275.748  c16.744-24.469,27.606-52.939,31.045-83.098"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M145.93,91.898  c-4.529-0.353-9.184-0.093-13.859,0.85c-27.201,5.485-44.805,31.979-39.32,59.182l0.094-0.016  c7.418,36.792-6.293,72.938-32.779,95.876"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M167.608,273.324  c24.108-41.098,33.776-90.867,23.617-141.246l0.024-0.01c-3.023-14.988-12.424-27.063-24.807-33.967"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M72.457,201.992  c-5.228,13.461-13.877,25.422-25.095,34.611"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M209.084,207.06  c4.162-25.266,3.9-51.697-1.461-78.287l0.01-0.007c-7.31-36.25-42.617-59.709-78.865-52.4c-36.25,7.31-59.71,42.618-52.4,78.869  l0.078-0.016c1.736,8.61,2.084,17.178,1.197,25.47"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M190.006,266.909  c6.068-12.456,10.967-25.52,14.582-39.021"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M209.666,92.758  c6.883,9.447,11.887,20.496,14.35,32.705l0.005,0.004c9.095,45.104,4.563,89.789-10.744,129.806"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M107.07,65.952  c5.76-2.64,11.913-4.663,18.393-5.969c25.609-5.163,50.842,1.962,69.588,17.315"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M36.275,224.05  c18.902-15.185,28.896-40.118,23.771-65.524l-0.063,0.014c-6.366-31.567,5.94-62.562,29.315-81.544"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M41.684,145.976  c0.215,5.25,0.844,10.552,1.916,15.867l0.051-0.013c3.752,18.607-3.295,36.881-16.821,48.343"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M242.69,135.156  c-0.642-4.326-1.399-8.658-2.272-12.994l-0.02-0.001C229.44,67.813,176.506,32.643,122.16,43.6  c-41.765,8.422-72.207,41.635-79.088,81.229"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M236.983,236.258  c6.826-25.603,9.664-52.564,7.931-80.029"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M157.688,25.931  c-12.592-1.701-25.675-1.366-38.83,1.287C55.461,40,14.432,101.75,27.215,165.146l0.039-0.01c2.219,11-1.225,21.823-8.313,29.47"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
      <path
        d="M260.104,204.896  c3.479-27.945,2.584-56.916-3.289-86.041l-0.033,0.002c-8.693-43.112-40.031-75.878-79.129-88.413"
        fill="none"
        stroke="#000000"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-width="8"
      />
    </svg>
    <svg
      width="40px"
      height="40px"
      style="enable-background: new 0 0 24 24"
      version="1.1"
      viewBox="0 0 24 24"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <style type="text/css">
        .st0 {
          display: none;
        }

        .st1 {
          display: inline;
        }

        .st2 {
          opacity: 0.2;
          fill: none;
          stroke: #000000;
          stroke-width: 5e-2;
          stroke-miterlimit: 10;
        }
      </style>
      <g class="st0" id="grid_system" />
      <g id="_icons">
        <path
          d="M21,7c0-2.2-1.8-4-4-4h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c1.1,0,2,0.9,2,2v1.1c0,0.6,0.4,1,1,1s1-0.4,1-1V7z"
        />
        <path
          d="M21,16c0-0.6-0.4-1-1-1s-1,0.4-1,1v1c0,1.1-0.9,2-2,2h-1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c2.2,0,4-1.8,4-4V16z"
        />
        <path
          d="M3,17c0,2.2,1.8,4,4,4h1c0.6,0,1-0.4,1-1s-0.4-1-1-1H7c-1.1,0-2-0.9-2-2v-1c0-0.6-0.4-1-1-1s-1,0.4-1,1V17z"
        />
        <path
          d="M3,8c0,0.6,0.4,1,1,1s1-0.4,1-1V7c0-1.1,0.9-2,2-2h1c0.6,0,1-0.4,1-1S8.6,3,8,3H7C4.8,3,3,4.8,3,7V8z"
        />
        <path
          d="M10,9V8c0-0.6-0.4-1-1-1S8,7.4,8,8v1c0,0.6,0.4,1,1,1S10,9.6,10,9z"
        />
        <path
          d="M16,9V8c0-0.6-0.4-1-1-1s-1,0.4-1,1v1c0,0.6,0.4,1,1,1S16,9.6,16,9z"
        />
        <path
          d="M11.1,14c0,0.6,0.4,1,1,1c0.7,0,1.3-0.3,1.6-0.8c0.3-0.5,0.3-1.1,0.1-1.6l-0.9-2c-0.2-0.5-0.8-0.7-1.3-0.5   c-0.5,0.2-0.7,0.8-0.5,1.3l0.8,1.6C11.4,13.2,11.1,13.6,11.1,14z"
        />
        <path
          d="M8.3,16.7C8.4,16.8,9.7,18,12,18s3.6-1.2,3.7-1.3c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0c0,0-0.8,0.7-2.3,0.7   c-1.5,0-2.3-0.7-2.3-0.7c-0.4-0.4-1-0.4-1.4,0C7.9,15.7,7.9,16.3,8.3,16.7z"
        />
      </g>
    </svg>
  </div>

  <br /><br />
  <a class="text-center margin-t-2" (click)="back()">{{
    "biometric.back" | i18next
  }}</a>
</div>
